import Quiz from "../Project-pictures/Quiz.jpg";
import Employee from "../Project-pictures/Employee.jpg";
import Jeronivosh from "../Project-pictures/Jeronivosh.jpg";
import Shrek from "../Project-pictures/Shrek.jpg";
import Weather from "../Project-pictures/Weather.jpg";
import Books from "../Project-pictures/Books.jpg";

const Projects = [
  {
    name: "TimedQuiz",
    github: "https://github.com/Marcmuylaer/TimedQuiz-music",
    Deployed: "https://Marcmuylaer.github.io/TimedQuiz-music/",
    img: Quiz,
    discription:
      "Music Timed Quiz mainly using, Vanilla JavaScript, Local Storage, DOM manipulation, and Bootstrap",
  },
  {
    name: "Weather App",
      github: "https://github.com/Marcmuylaer/wheater",
      Deployed: "https://marcmuylaer.github.io/wheater/",
    img: Weather,
    discription:
      "Weather App mainly using, jQuery, Ajax, Third party API, and local storage.",
  },
  {
    name: "Employee Directory",
    github: "https://github.com/Marcmuylaer/Employe-Directory-api-random-user",
    Deployed: "https://Marcmuylaer.github.io/Employe-Directory-api-random-user/",
    img:Employee,
    discription:
      "Employee Directory searches and updates search on change",
  },
];

export default Projects;
